import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { StorageConfigProvider } from '../providers/storage-config.provider';
import { Guid } from 'guid-typescript';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class RecursosHumanosEstabelecimentoService {

    constructor(
        private http: HttpClient,
        private baseService: BaseService,
        private storage: Storage,
        private storageConfig: StorageConfigProvider
    ) {

    }

    ListarTiposEquipes() {
        const url = `/cnes/tipos-equipe`;
        return this.baseService.get(url).toPromise();
    }

    listarSubTiposEquipes() {
        // const url = `/equipe/subtipo-equipe`;
        // return this.baseService.get(url).toPromise();
        return this.http.get('./assets/dados-fake/recursos-humanos/subtipos-equipe.json').toPromise();
    }

    listarAreasEquipes() {
        return this.http.get('./assets/dados-fake/recursos-humanos/areas.json').toPromise();
    }

    ListarMotivosDesativacao() {
        return this.http.get(`${environment.urlBaseNova}/cnes/motivos-desativacao-estabelecimento`).toPromise();
    }

    async listarProfissionais(idEstabelecimento) {
        return await this.storage.get(this.storageConfig.edicaoEstabelecimentoProfissionais + idEstabelecimento) || [];
    }

    async salvarProfissional(profissional, idEstabelecimento) {
        if (!profissional.id) {
            const id: any = Guid.create();
            profissional.id = id.value;
        }
        const profissionais: any[] = await this.listarProfissionais(idEstabelecimento);
        profissionais.push(profissional);
        await this.storage.set(this.storageConfig.edicaoEstabelecimentoProfissionais + idEstabelecimento, profissionais);
        return profissional;
    }

}
